<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <div class="panel panel-default no-margin">
            <div class="panel-heading">
              <h4 class="panel-title">Depósito</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <p><strong>Descrição:</strong> {{::deposito.descricao | capitalize}}</p>
                  <p><strong>Tipo:</strong> {{::deposito.tipo.descricao}}</p>
                  <p><strong>Proprietário:</strong> {{::deposito.proprietario.nome | capitalize}}</p>
                  <p><strong>Propriedade(s):</strong>  {{deposito.propriedades | getTextItems | capitalize}}</p>
                  <p ng-if="!!deposito.glebas && !!deposito.glebas.length"><strong>Talhões:</strong>  {{deposito.glebas | getTextItems | capitalize}}</p>
                  <p><strong>Em uso:</strong>  {{deposito.em_uso ? 'Sim' : 'Não'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row pull-right padding-top-10" ng-include="'views/depositos/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
